import type {
  KycStatusResponse,
  KycStatusResponseScore,
  ReasonsAndActions,
} from 'apiConnector/secondary-market/cp-order/model';
import type { A2DReasonAndAction, SecondaryMarketKycResponse } from 'apiConnector/secondary-market/shared/kyc';
import type { Collection } from 'state/utils/types';

export type KycMap = Collection<Kyc>;

export type KycScoreStatus = 'green' | 'red' | 'restricted';

export type KycDetail = {
  action: string;
  reason: string;
};

export type KycData = {
  score: KycScoreStatus;
  details: readonly KycDetail[];
};

export type Kyc = {
  data?: KycData;
  isLoading: boolean;
  hasError: boolean;
};

export const initialKycMap = (): KycMap => ({});

const defaultDetails: readonly [] = [];
export function mapKycResponse(response: KycStatusResponse | SecondaryMarketKycResponse): KycData {
  return {
    score: mapKycScore(response.score ?? undefined),
    details: mapKycDetails(response.reasonsAndActions ?? defaultDetails),
  };
}

function mapKycDetails(
  reasonsAndActions: readonly ReasonsAndActions[] | readonly A2DReasonAndAction[],
): readonly KycDetail[] {
  return reasonsAndActions.map(x => {
    return { action: x.action!, reason: x.reason! };
  });
}

function mapKycScore(statusResponse: KycStatusResponseScore | string | undefined): KycScoreStatus {
  switch (statusResponse) {
    case 'green':
      return 'green';
    case 'red':
      return 'red';
    case 'orange':
      return 'restricted';
    default:
      return undefined as never;
  }
}
